import { useQueryParam, withDefault } from "use-query-params";

import {
  CustomJsonParam,
  type DateRangeChoiceV4,
  type FixedDateInterval,
} from "@north-beam/nb-common";

const DateRangeQueryParam = CustomJsonParam<
  FixedDateInterval | DateRangeChoiceV4
>();

export const useDateRangeQueryParams = () => {
  const [dateRange, setDateRange] = useQueryParam(
    "dateRange",
    withDefault<
      FixedDateInterval | DateRangeChoiceV4,
      FixedDateInterval | DateRangeChoiceV4
    >(DateRangeQueryParam, "last7Days"),
    { updateType: "pushIn" },
  );

  return { dateRange, setDateRange };
};
